import React, { useState, createContext, useContext } from 'react';
type PricingOption = 'standard' | 'premium';
interface PricingContextType {
  selectedOption: PricingOption;
  setSelectedOption: (option: PricingOption) => void;
}
const PricingContext = createContext<PricingContextType>({
  selectedOption: 'premium',
  setSelectedOption: () => {}
});
export function PricingProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [selectedOption, setSelectedOption] = useState<PricingOption>('premium');
  return <PricingContext.Provider value={{
    selectedOption,
    setSelectedOption
  }} data-id="element-383">
      {children}
    </PricingContext.Provider>;
}
export function usePricing() {
  return useContext(PricingContext);
}